import React, { useMemo, useCallback } from 'react';
import { VariableSizeList as List } from 'react-window';

const ImportCommon = ({ loadingIs, showImg, items, tableHeaders, targetColumns }) => {
    // Function to calculate dynamic column widths based on the content
    const calculateColumnWidths = useCallback(() => {
        // Default minimum width for each column
        const minWidths = Array(targetColumns.length).fill(180);
        // console.log({ items, minWidths, targetColumns })

        // Iterate through each item to determine the maximum width needed for each column
        items.forEach(item => {
            targetColumns.forEach((col, index) => {
                const content = item[col] || '';
                // Set the width to the length of the content times 8 (adjust this factor as needed)
                // const contentWidth = Math.max(minWidths[index], content.length * 8);
                // minWidths[index] = Math.max(minWidths[index], contentWidth);

                const contentWidth = content ? Math.max(minWidths[index], content.length * 8) : minWidths[index];

                // Ensure the calculated width is a valid number, else use the default width
                minWidths[index] = isNaN(contentWidth) ? minWidths[index] : contentWidth;
            });
        });
        return minWidths;
    }, [items, targetColumns]);

    // Use the function to get dynamic column widths
    const columnWidths = useMemo(() => calculateColumnWidths(), [calculateColumnWidths]);

    const tableBody = ({ index, isScrolling, style }) => (
        <div style={{ ...style, display: 'flex', borderBottom: '1px solid #eee' }}>
            {isScrolling ? (
                <div>Loading...</div>
            ) : (
                targetColumns.map((ele, i) => (
                    <div
                        key={i}
                        style={{
                            flex: 2,
                            minWidth: columnWidths[i],
                        }}
                    >
                        {items[index][ele]}
                    </div>
                ))
            )}
        </div>
    );

    return (
        <>
            <div style={{ display: 'flex', borderBottom: '1px solid #ddd', fontWeight: 'bold' }}>
                {tableHeaders.map((ele, i) => (
                    <div style={{ ...ele.style, minWidth: columnWidths[i] }} key={i}>
                        {ele.label}
                        {ele.showStar && <span style={{color:"red"}}>*</span>}
                    </div>
                ))}
            </div>
            {loadingIs ? (
                <div className="spinner spinner-secondary"></div>
            ) : showImg ? (
                <div className="d-flex justify-content-center align-items-center">
                    Import Icon
                </div>
            ) : (
                <List
                    useIsScrolling
                    height={255}
                    itemCount={items.length}
                    itemSize={() => 50}
                    // width={columnWidths.reduce((total, width) => total + width, 40)}
                    width={columnWidths.reduce((total, width) => {
                        return total + (isNaN(width) ? 0 : width); // Fallback to 0 if width is NaN
                    }, 40)}
                >
                    {tableBody}
                </List >
            )}
        </>
    );
};

export default ImportCommon;
